import * as React from "react";
const IconChevronLeftCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M43.3 56c-.3 0-.5-.1-.7-.3L20 32.7c-.4-.4-.4-1 0-1.4l22.6-23c.4-.4 1-.4 1.4 0s.4 1 0 1.4L22.1 32 44 54.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3" />
  </svg>
);
export default IconChevronLeftCopy;
